AFRAME.registerComponent('cursor-listener', {
    init: function () {
        this.originalColor =  this.el.getAttribute('color') || '#0066cc';

        this.el.addEventListener('mouseenter', () => {
            this.el.setAttribute('material', 'opacity', 1.0);
            this.el.setAttribute('color', '#3399ff');
        });

        this.el.addEventListener('mouseleave', () => {
            this.el.setAttribute('material', 'opacity', 0.8);
            this.el.setAttribute('color', this.originalColor);
        });
    }
});

AFRAME.registerComponent('ticker-news', {
    schema: {
        ticker: { type: 'string', default: 'BUSINESS' },
        position: { type: 'vec3' }
    },

    init: async function () {
        this.articles = [];
        this.currentMode = 'market-summary';
        this.currentFilter = 'market-summary';
        this.activeWatchlistId = null;
        this.lastNarrativeData = null;

        this.themeMode = 'Dark';
        const mainSettings = (typeof getCacheItem === 'function') ? getCacheItem('mainSettings') : null;
        if (mainSettings && (mainSettings.themeMode === 'Light' || mainSettings.themeMode === 'Dark')) {
            this.themeMode = mainSettings.themeMode;
        }
        this.mainContentColor = (this.themeMode === 'Dark') ? '#fff' : '#111';

        this.onFilterChanged = this.onFilterChanged.bind(this);
        this.onWatchlistDataLoaded = this.onWatchlistDataLoaded.bind(this);
        this.onThemeChanged = this.onThemeChanged.bind(this);

        this.el.sceneEl.addEventListener('news-filter-changed', this.onFilterChanged);
        document.body.addEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        this.el.sceneEl.addEventListener('theme-changed', this.onThemeChanged);

        try {
            this.apiManager = await NewsProxyAPIManager.create();
            try {
                this.lastNarrativeData = await this.apiManager.fetchNarrativeTickerMap();
            } catch (e) {
                console.error('init: Failed to pre-fetch narrative ticker map:', e.message);
            }
        } catch (error) {
            console.error('init: Failed to initialize MediastackAPIManager: ', error.message);
            return;
        }

        this.el.sceneEl.addEventListener('chart-type-changed', (evt) => {
            const action = evt.detail.action;
            if (action === 'watchlist-reports') {
                if (this.currentMode !== 'watchlist-news') {
                    this.el.sceneEl.emit('set-news-filter-ui', { filter: 'watchlist-news' });
                    this.onFilterChanged({ detail: { filter: 'watchlist-news' } });
                }
            } else {
                if (this.data.ticker !== 'BUSINESS') {
                    this.el.setAttribute('ticker-news', 'ticker', 'BUSINESS');
                }
                if (this.currentMode !== 'market-summary') {
                    this.el.sceneEl.emit('set-news-filter-ui', { filter: 'market-summary' });
                    this.onFilterChanged({ detail: { filter: 'market-summary' } });
                }
            }
        });

        try {
            if (document.body.classList.contains('watchlist-mode')) {
                this.currentMode = 'watchlist-news';
                this.currentFilter = 'watchlist-news';
            } else if (this.data.ticker && this.data.ticker.toUpperCase() !== 'BUSINESS') {
                this.currentMode = 'ticker-news';
                this.currentFilter = 'ticker-news';
            } else {
                this.currentMode = 'market-summary';
                this.currentFilter = 'market-summary';
            }
        } catch (e) {
            console.error(e);
        }

        await this.refreshNews();

        if (window.AutoRefreshScheduler && !this.newsScheduler) {
            this.newsScheduler = new window.AutoRefreshScheduler({
                name: 'NewsTabVR',
                scheduleType: 'fixed-30',
                onRefresh: () => this.update({ ticker: 'FORCE_UPDATE' })
            });
            this.newsScheduler.start();
        }
    },

    remove: function () {
        if (this.newsScheduler) {
            this.newsScheduler.stop();
        }
        if (this.onFilterChanged) this.el.sceneEl.removeEventListener('news-filter-changed', this.onFilterChanged);
        if (this.onWatchlistDataLoaded) document.body.removeEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        if (this.onThemeChanged) this.el.sceneEl.removeEventListener('theme-changed', this.onThemeChanged);
    },

    onFilterChanged: async function(evt) {
        const filter = evt.detail ? evt.detail.filter : null;
        const force = !!(evt.detail && evt.detail.force);

        if (filter === 'news-graph') {
            this.currentMode = 'news-graph';
            this.currentFilter = 'news-graph';
            return;
        }

        const isGeneralFilter = ['market-summary', 'business-headlines', 'trending-stock'].includes(filter);
        const needsTickerReset = (isGeneralFilter && this.data.ticker !== 'BUSINESS');

        if (this.currentMode !== filter || needsTickerReset || force) {
            if (filter === 'watchlist-news') {
                const WA = window.WatchlistApp || {};
                const Manager = WA.Manager;
                if (Manager && Manager.checkAuthorization) {
                    const auth = await Manager.checkAuthorization();
                    if (!auth.authorized) {
                        if (window.AuthUI && window.AuthUI.showMessage) {
                            window.AuthUI.showMessage(auth.message || 'Log in to access watchlist');
                        }
                        this.el.sceneEl.emit('set-news-filter-ui', { filter: this.currentMode });
                        return;
                    }
                }
            }

            this.currentMode = filter;
            this.currentFilter = filter;

            if (isGeneralFilter) {
                this.el.setAttribute('ticker-news', 'ticker', 'BUSINESS');
                this.el.sceneEl.emit('update-news-type-2', 'BUSINESS');
            } else if (filter === 'watchlist-news') {
                const WA = window.WatchlistApp || {};
                const State = WA.State || {};
                const Manager = WA.Manager || {};

                if (!State.allWatchlists || State.allWatchlists.length === 0) {
                    if (Manager.updateWatchlistState) {
                        await Manager.updateWatchlistState();
                    }
                }
                if (!this.activeWatchlistId) {
                    this.activeWatchlistId = State.currentWatchlistId;
                }
                if (!this.activeWatchlistId && State.allWatchlists && State.allWatchlists.length > 0) {
                    this.activeWatchlistId = State.allWatchlists[0].id || State.allWatchlists[0].watchlist_id;
                }
                const firstWatchlistName = (State.allWatchlists && State.allWatchlists.length > 0)
                    ? (State.allWatchlists[0].name || 'Watchlist')
                    : 'Watchlist';
                this.el.sceneEl.emit('update-news-type-2', firstWatchlistName);
            }

            this.update({ ticker: 'FORCE_UPDATE' });
        }
    },

    onThemeChanged: function(evt) {
        if (!evt.detail || !evt.detail.themeMode) return;
        this.themeMode = evt.detail.themeMode;
        this.mainContentColor = (this.themeMode === 'Dark') ? '#fff' : '#111';
    },

    onWatchlistDataLoaded: function(evt) {
        const chartTypeControl = document.querySelector('[chart-type-control]');
        const chartData = chartTypeControl ? chartTypeControl.getAttribute('chart-type-control') : null;
        const currentAction = chartData ? chartData.selectedPrimeAction : null;

        if (currentAction !== 'watchlist-reports') {
            return;
        }

        this.currentMode = 'watchlist-news';
        this.currentFilter = 'watchlist-news';

        const WA = window.WatchlistApp || {};
        const State = WA.State || {};

        if (State.currentWatchlistId) {
            this.activeWatchlistId = State.currentWatchlistId;
        }

        this.el.sceneEl.emit('set-news-filter-ui', { filter: 'watchlist-news' });
        this.update({ ticker: 'FORCE_UPDATE' });
    },

    setTicker: function (ticker) {
        this.currentMode = 'ticker-news';
        this.currentFilter = 'ticker-news';
        this.data.ticker = ticker;
        this.update({ ticker: 'FORCE_UPDATE' });
    },

    update: async function (oldData) {
        if (!this.apiManager || this.apiManager.isInitialized === false) {
            return;
        }

        const isForce = !oldData || oldData.ticker === 'FORCE_UPDATE';

        if (oldData && oldData.ticker !== this.data.ticker && !isForce) {
            if (this.currentMode === 'watchlist-news') {
                this.currentMode = 'market-summary';
                this.currentFilter = 'market-summary';
                this.el.sceneEl.emit('set-news-filter-ui', { filter: 'market-summary' });
            }
        }

        if (isForce || oldData.ticker !== this.data.ticker || oldData.position !== this.data.position) {
            if (this.data.ticker !== 'BUSINESS' && !isForce) {
                this.currentMode = 'ticker-news';
                this.currentFilter = 'ticker-news';
            }
            await this.refreshNews();
        }
    },

    refreshNews: async function () {
        try {
            const result = await this.fetchArticles();
            this.broadcastNewsData(result);
        } catch (error) {
            console.error('refreshNews: Failed to fetch articles:', error.message);
            this.broadcastNewsData({ noArticles: true, error: error.message });
        }
    },

    broadcastNewsData: function (payload) {
        const rawPayload = this.lastNarrativeData;
        const priceMap = NewsProxyAPIManager.buildTickerPriceMap(rawPayload);

        const eventData = {
            mode: this.currentMode,
            ticker: this.data.ticker,
            items: payload.items || [],
            noArticles: !!payload.noArticles,
            watchlistName: payload.watchlistName || '',
            tickerSymbol: payload.tickerSymbol || '',
            exchange: payload.exchange || '',
            rawPayload: rawPayload,
            priceMap: priceMap
        };

        let headerTitleText = this.data.ticker;
        if (this.currentMode === 'watchlist-news') {
            headerTitleText = payload.watchlistName || 'Watchlist';
        }
        this.el.sceneEl.emit('update-news-type-2', headerTitleText);
        this.el.sceneEl.emit('update-news-list-2', payload.items || []);

        this.el.sceneEl.emit('update-news-data-3d', eventData);
    },

    async fetchArticles() {
        if (!this.apiManager) {
            throw new Error("Mediastack Manager not initialized yet.");
        }

        if (this.currentMode === 'watchlist-news') {
            const WA = window.WatchlistApp || {};
            const State = WA.State || {};

            let userId = State.currentUserId || (window.currentSession && window.currentSession.user_id) || (window.currentSession && window.currentSession.user && window.currentSession.user.id);

            if (!userId) {
                try {
                    const sessionStr = localStorage.getItem('auth_session');
                    if (sessionStr) {
                        const sessionItem = JSON.parse(sessionStr);
                        userId = sessionItem.value?.user?.id || sessionItem.value?.user?.user_id;
                    }
                } catch(e) {}
            }

            let watchlistId = this.activeWatchlistId || State.currentWatchlistId;
            const allWatchlists = State.allWatchlists || [];

            if (!watchlistId && allWatchlists.length > 0) {
                watchlistId = allWatchlists[0].id || allWatchlists[0].watchlist_id;
                this.activeWatchlistId = watchlistId;
            }

            const currentWatchlist = allWatchlists.find(w => w.id === watchlistId);
            const watchlistName = currentWatchlist ? currentWatchlist.name : 'Watchlist';

            if (userId && watchlistId) {
                try {
                    const articles = await this.apiManager.getWatchlistNews(userId, watchlistId);
                    return { items: articles, watchlistName: watchlistName };
                } catch (err) {
                    console.error('fetchArticles: Failed to fetch watchlist news:', err);
                    return { noArticles: true, watchlistName: watchlistName };
                }
            } else {
                if (!userId) {
                    return { noArticles: true, watchlistName: "Please Log In" };
                }
                return { noArticles: true, watchlistName: "No Watchlist" };
            }
        }

        if (['market-summary', 'business-headlines', 'trending-stock'].includes(this.currentMode)) {
            let data = this.lastNarrativeData;
            if (!data) {
                try {
                    data = await this.apiManager.fetchNarrativeTickerMap();
                    this.lastNarrativeData = data;
                } catch (e) {
                    console.error('fetchArticles: Failed to fetch narrative map:', e);
                    return { noArticles: true };
                }
            }

            if (this.currentMode === 'market-summary') {
                if (!data || !Array.isArray(data.narratives)) {
                    return { noArticles: true };
                }
                let narratives = [...data.narratives];
                const lists = data.lists || data.rankings || {};
                if (Array.isArray(lists.market_narratives)) {
                    const map = {};
                    data.narratives.forEach(n => { if (n.id) map[n.id] = n; });
                    narratives = lists.market_narratives.map(id => map[id]).filter(Boolean);
                }
                narratives.sort((a, b) => (a.rank || Infinity) - (b.rank || Infinity));
                return { items: narratives };
            }

            if (this.currentMode === 'business-headlines') {
                const articles = data?.articles || {};
                const lists = data?.lists || data?.rankings || {};
                let summaryIds = lists.summary_articles || [];

                if (!summaryIds.length && data?.lists?.market_narratives && Array.isArray(data.narratives)) {
                    const seen = new Set();
                    data.lists.market_narratives.slice(0, 6).forEach(nid => {
                        const n = data.narratives.find(narr => narr.id === nid);
                        if (n && n.article_ids) {
                            n.article_ids.forEach(aid => {
                                if (!seen.has(aid) && articles[aid]) {
                                    seen.add(aid);
                                    summaryIds.push(aid);
                                }
                            });
                        }
                    });
                }
                summaryIds = summaryIds
                    .filter(aid => !!articles[aid])
                    .sort((a, b) => {
                        const aTime = new Date(articles[a]?.published_at || 0).getTime() || 0;
                        const bTime = new Date(articles[b]?.published_at || 0).getTime() || 0;
                        return bTime - aTime;
                    });
                return { items: summaryIds.map(aid => articles[aid]) };
            }

            if (this.currentMode === 'trending-stock') {
                const tickers = data?.tickers || [];
                const lists = data?.lists || data?.rankings || {};
                const trendingRefs = lists.trending_tickers || [];

                const tickerMap = {};
                tickers.forEach(t => { if (t?.id) tickerMap[t.id] = t; });

                const trendingTickerItems = trendingRefs
                    .map(ref => tickerMap[ref])
                    .filter(Boolean);

                trendingTickerItems.sort((a, b) => (a.rank || Infinity) - (b.rank || Infinity));
                return { items: trendingTickerItems.slice(0, 20) };
            }
        }

        let tickerSymbol = this.data.ticker;
        if (tickerSymbol.includes(':')) {
            tickerSymbol = tickerSymbol.split(':')[1];
        }
        const exchange = this.getExchangeFromCache(tickerSymbol);
        const searchTerm = exchange ? `${exchange}:${tickerSymbol}` : tickerSymbol;

        try {
            const articles = await this.apiManager.fetchStockNews(searchTerm, 20);
            if (!articles || articles.length === 0) {
                return { noArticles: true, tickerSymbol, exchange };
            }
            return { items: articles, tickerSymbol, exchange };
        } catch (error) {
            console.error(`Error fetching news for ${searchTerm}:`, error.message);
            return { noArticles: true, tickerSymbol, exchange, error: error.message };
        }
    },

    getExchangeFromCache: function(ticker) {
        if (!ticker) return null;
        try {
            if (typeof getCacheItem === 'function') {
                const cacheKey = `ticker_${ticker}`;
                const cachedData = getCacheItem(cacheKey);
                if (cachedData && cachedData.tickerSummary && cachedData.tickerSummary.primary_exchange) {
                    const exchange = cachedData.tickerSummary.primary_exchange;
                    if (exchange !== 'Unknown Exchange') {
                        return exchange;
                    }
                }
            } else {
                 const cacheKey = `ticker_${ticker}`;
                 const itemStr = localStorage.getItem(cacheKey);
                 if (itemStr) {
                     const item = JSON.parse(itemStr);
                     const cachedData = item.value;
                     if (cachedData && cachedData.tickerSummary && cachedData.tickerSummary.primary_exchange) {
                        const exchange = cachedData.tickerSummary.primary_exchange;
                        if (exchange !== 'Unknown Exchange') return exchange;
                     }
                 }
            }
            return null;
        } catch (e) {
            console.warn('ticker-news: Error getting exchange from cache:', e);
            return null; 
        }
    },

    openTickerFromPill: function (symbol) {
        if (!symbol) return;
        const normalizedSymbol = String(symbol).toUpperCase();

        const exchange = this.getExchangeFromCache(normalizedSymbol);
        let exchangeStr = exchange || 'Unknown Exchange';
        if (exchangeStr === 'New York Stock Exchange') exchangeStr = 'NYSE';

        const formattedTicker = exchangeStr !== 'Unknown Exchange'
            ? `${exchangeStr}:${normalizedSymbol}`
            : normalizedSymbol;

        const tickerNewsEl = document.getElementById('ticker-news') || document.querySelector('[ticker-news]');
        if (tickerNewsEl && tickerNewsEl.components['ticker-news']) {
            tickerNewsEl.components['ticker-news'].setTicker(formattedTicker);
        } else if (typeof window.addTickerNewsToLeftPanel === 'function') {
            window.addTickerNewsToLeftPanel(formattedTicker);
            const tEl = document.getElementById('ticker-news') || document.querySelector('[ticker-news]');
            if (tEl && tEl.components['ticker-news']) {
                tEl.components['ticker-news'].setTicker(formattedTicker);
            }
        }

        const scene = this.el.sceneEl || document.querySelector('a-scene');
        if (scene) {
            const cachedStock = (typeof getCacheItem === 'function')
                ? getCacheItem(`ticker_${normalizedSymbol}`)
                : null;
            const stock = {
                ticker: normalizedSymbol,
                primary_exchange: exchange || 'Unknown Exchange',
                tickerDetails: cachedStock?.tickerDetails || null,
                tickerSummary: cachedStock?.tickerSummary || { name: normalizedSymbol, primary_exchange: exchange || 'Unknown Exchange' }
            };
            scene.emit('stock-selected', stock);

            const searchModeEl = document.querySelector('[search-mode]') || document.querySelector('.search-container');
            if (searchModeEl && searchModeEl.components['search-mode']) {
                searchModeEl.components['search-mode'].enterSearchMode(stock);
            }
        }
    }
});
